export const POST_HEADERS = { "Accept": "application/json", "Content-Type": "application/json" };
export const GET_HEADERS = { Accept: "application/json" };

export class Common {
  static handleResponse(resp: any, dataType: string) {
    if (!resp.ok) {
      if (resp.message === "Access is denied") resp.status = 403;

      if (resp.status == 403) throw "Permission Denied";
      else if (resp.status == 401) throw "Access Denied";
      else throw `Couldn't fetch ${dataType}`;
    } else return resp;
  }

  static uploadError(e: Error | any) {
    var status = e.detail.xhr.status;
    if (status == 401) {
      e.detail.file.error = "You are logged out.";
      document.dispatchEvent(new CustomEvent("logged-out", { bubbles: true, composed: true }));
    } else e.detail.file.error = "Sorry, We're having trouble uploading this file.";
  }
}
